(function () {
  function initStickyAtc(bar) {
    var realButton = document.getElementById(bar.dataset.realButton);
    if (!realButton) return;

    var stickyPrice = bar.querySelector('.veizu-sticky-atc__price');
    var stickyButton = bar.querySelector('.veizu-sticky-atc__button');
    var stickyText = bar.querySelector('.veizu-sticky-atc__button-text');
    var priceSource = document.getElementById(bar.dataset.priceSource);
    var variantPicker = document.getElementById(bar.dataset.variantPicker);

    // Leiste zeigen, wenn der echte Buy-Button NICHT im sichtbaren Bereich ist
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(realButton);

    // Preis aus dem echten Preis-Element spiegeln (auch bei Variantenwechsel)
    if (priceSource && stickyPrice) {
      var syncPrice = function () {
        stickyPrice.innerHTML = priceSource.innerHTML;
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
      });
    }

    // Zustand (Label + ausgegraut) vom echten Button spiegeln – aber NICHT
    // nativ disablen, damit der Tap fürs Hochscrollen erhalten bleibt
    var syncState = function () {
      stickyButton.classList.toggle('is-disabled', realButton.disabled);
      var realText = realButton.querySelector('span');
      if (realText && stickyText) {
        stickyText.textContent = realText.textContent.trim();
      }
    };
    syncState();
    new MutationObserver(syncState).observe(realButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });

    // Tap: wenn echter Button deaktiviert ist (z.B. Variante ausverkauft/
    // nicht gewählt) -> sanft zur Varianten-Auswahl scrollen statt Fehler
    stickyButton.addEventListener('click', function (event) {
      if (realButton.disabled) {
        event.preventDefault();
        if (variantPicker) {
          variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          variantPicker.classList.add('veizu-variant-highlight');
          setTimeout(function () {
            variantPicker.classList.remove('veizu-variant-highlight');
          }, 1500);
        }
      }
      // sonst: type=submit + form-Attribut löst das echte Formular automatisch aus
    });
  }

  function init() {
    var bars = document.querySelectorAll('.veizu-sticky-atc');
    for (var i = 0; i < bars.length; i++) {
      initStickyAtc(bars[i]);
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
